import { useEffect, useState, useCallback } from 'react';
import throttle from 'lodash/throttle';

export const ReadProgressBar = ({ elementRef }) => {
  const ReadingProgress = useReadProgress(elementRef);
  return (
    <div
      style={{ width: ReadingProgress + '%' }}
      className="fixed top-0 right-0 left-0 z-[11111] h-1.5 bg-red transition-all duration-200 ease-linear"
    />
  );
};

export default ReadProgressBar;

const useReadProgress = (elementRef) => {
  const [readingProgress, setReadingProgress] = useState(0);

  const handleScroll = useCallback(
    throttle(() => {
      if (!elementRef.current) return;

      const element = elementRef.current;
      const elementRect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollBottom = scrollTop + windowHeight;
      const elementTop = scrollTop + elementRect.top;
      const elementBottom = scrollTop + elementRect.bottom;

      // If scrolling from bottom to top, manually set progress to 0 if scrollTop is less than a threshold
      if (scrollTop < 10) {
        setReadingProgress(0);
      } else if (elementTop >= scrollTop && elementBottom <= scrollBottom) {
        // If element is fully visible in the viewport, set progress to 100%
        setReadingProgress(100);
      } else {
        // Calculate progress based on element's position in the viewport
        const progress = Math.floor(
          ((scrollBottom - elementTop) / (elementRect.height + windowHeight)) * 100
        );
        setReadingProgress(progress);
      }
    }, 10),
    [elementRef]
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      // handleScroll.cancel();
    };
  }, [handleScroll]);

  return readingProgress;
};
